export enum PAYMENT_METHOD {
  card = 'card',
  ideal = 'ideal',
  paypal = 'paypal',
  sofort = 'sofort',
  app_store = 'app_store',
  play_store = 'play_store',
}

export enum PAYMENT_INTERVALS {
  month = 'month',
  year = 'year',
}

// Should match currencies in lib/nu/config.rb
export enum CURRENCIES {
  eur = 'eur',
  usd = 'usd',
  cad = 'cad',
  gbp = 'gbp',
}

export enum SUBSCRIPTION_STATUS {
  active = 'active',
  past_due = 'past_due',
  trialing = 'trialing',
  pending = 'pending',
  canceled = 'canceled',
  unpaid = 'unpaid',
  incomplete = 'incomplete',
  incomplete_expired = 'incomplete_expired',
}

export const INACTIVE_SUBSCRIPTION_STATUS = [
  SUBSCRIPTION_STATUS.pending,
  SUBSCRIPTION_STATUS.canceled,
  SUBSCRIPTION_STATUS.incomplete,
  SUBSCRIPTION_STATUS.incomplete_expired,
];

export interface Plan {
  name: string;
  amount: number;
  currency: CURRENCIES;
  interval: PAYMENT_INTERVALS;
  interval_count: number;
}

export interface Order {
  plan_id: number;
  name: string;
  country_code: string | null;
  state_code: string | null;
  currency: CURRENCIES;
  interval: PAYMENT_INTERVALS;
  interval_count: number;
  tax_percent: number | null;
  coupon_code: string | null;
  subtotal: number;
  subtotal_cents: number;
  discount: number;
  discount_cents: number;
  discount_percent: number | null;
  tax: number;
  tax_cents: number;
  total: number;
  total_cents: number;
  total_per_seat: number;
  total_cents_per_seat: number;
  total_excluding_discount: number;
  total_cents_excluding_discount: number;
  skip_payment: boolean;
  error?: string | null;
}

export interface Checkout {
  ideal: {
    code: string;
    name: string;
  }[];
  order: Order;
  payment_methods: PAYMENT_METHOD;
}

export interface Pricing {
  month: Order;
  year: Order;
}

export interface Subscription {
  id: number;
  plan: Plan;
  payment_method?: PAYMENT_METHOD;
  status: SUBSCRIPTION_STATUS;
  tax_percent: number;
  started_at: string;
  ends_at: string;
  cancel_at_period_end: boolean;
  unique_id: string;
  upgraded: boolean;
  order: Order;
  quantity: number;
  scopes: Scopes;
}

export interface InvoiceSlice {
  list: Invoice[];
}

export interface Invoice {
  amount: number;
  created: string;
  currency: CURRENCIES;
  date: string;
  download_url: string;
  end_at: string;
  ended_at: string;
  id: number;
  number: string;
  paid: boolean;
  paid_at: string | null;
  start_at: string;
  started_at: string;
  subtotal: number;
  tax: number;
  tax_percent: number;
  total: number;
  hosted_invoice_url: string;
}

export interface UnpaidInvoice extends Invoice {
  amount_due: number;
  payment_pending: boolean;
}

export interface BillingPreview {
  recurring_total_cents: number;
  recurring_total: number;
  recurring_at: string;
  upfront_total_cents: number;
  upfront_total: number;
  currency: CURRENCIES;
  interval: PAYMENT_INTERVALS;
}

export enum CONTACT_BANK_ERROR_CODES {
  do_not_honor = 'do_not_honor',
  transaction_not_allowed = 'transaction_not_allowed',
  pickup_card = 'pickup_card',
}

export interface Scopes {
  web_manageable: boolean;
  can_have_seats: boolean;
  can_change_country_and_currency: boolean;
}
